import { ArrowRight, ArrowUpRight } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/cn";
import { AppLink } from "../primitives/link";

// Arrow semantics (P12): → stays in the console, ↗ leaves it or opens a new tab. External links always open in a
// new tab and say so to assistive technology.
export function ActionLink({
  href,
  external = false,
  children,
  className,
  ...rest
}: Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { href: string; external?: boolean }) {
  const cls = cn(
    "nd-above inline-flex items-center gap-1 text-ui font-medium text-fg-secondary hover:text-fg-primary",
    className,
  );
  if (external) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} {...rest}>
        {children}
        <ArrowUpRight className="size-3.5" aria-hidden />
        <span className="sr-only">(opens in a new tab)</span>
      </a>
    );
  }
  return (
    <AppLink href={href} className={cls} {...rest}>
      {children}
      <ArrowRight className="size-3.5" aria-hidden />
    </AppLink>
  );
}
